module.exports = __webpack_public_path__ + "img/HappyPocket-G.3902491e.png";